import {GET_CHECKOUT_MESSAGE_SUCCESS} from '../actions/api'
import {CLOSE_SLIDING_MODAL, OPEN_SLIDING_MODAL} from '../actions/modal'
import {
  CLOSE_DASHBOARD,
  CLOSE_EDIT_PARTICIPANT_FORM,
  CLOSE_EVENT_DETAILS,
  CLOSE_PARTICIPANT_FORM,
  CLOSE_USER_FORM,
  ENTER_EVENT_DETAIL_EDIT_MODE,
  LEAVE_EVENT_DETAIL_EDIT_MODE,
  OPEN_DASHBOARD,
  OPEN_EDIT_PARTICIPANT_FORM,
  OPEN_EVENT_DETAILS,
  OPEN_PARTICIPANT_FORM,
  OPEN_USER_FORM,
  SHOW_EVENT_DETAILS_LIST,
  SET_WEARER_TO_EDIT,
  SET_SECTIONS_OPEN,
  TOGGLE_EVENT_DETAILS,
  VALIDATE_DASHBOARD,
} from '../actions/dashboard'

const initialState = {
  bannerMessage: '',
  eventDetailToEdit: '',
  isOpen: false,
  shouldValidate: false,
  wearerToEdit: '',
}

export default function reducer(state = initialState, action) {
  let newState
  switch (action.type) {
    case ENTER_EVENT_DETAIL_EDIT_MODE:
      newState = {eventDetailToEdit: action.payload.eventDetailId}
      break
    case CLOSE_DASHBOARD:
      newState = {
        isOpen: false,
        errors: undefined,
        shouldValidate: false,
      }
      break
    case CLOSE_EDIT_PARTICIPANT_FORM:
      newState = {editParticipantFormVisible: false}
      break
    case CLOSE_EVENT_DETAILS:
      newState = {eventDetailsExpanded: false}
      break
    case CLOSE_PARTICIPANT_FORM:
      newState = {participantFormVisible: false}
      break
    case CLOSE_SLIDING_MODAL:
      newState = {
        slidingModalIsOpen: false,
        slidingModalContent: undefined,
      }
      break
    case CLOSE_USER_FORM:
      newState = {userFormVisible: false}
      break
    case GET_CHECKOUT_MESSAGE_SUCCESS:
      newState = {bannerMessage: action.payload.message || ''}
      break
    case LEAVE_EVENT_DETAIL_EDIT_MODE:
      newState = {eventDetailToEdit: ''}
      break
    case OPEN_DASHBOARD:
      newState = {isOpen: true}
      break
    case OPEN_EVENT_DETAILS:
      newState = {eventDetailsExpanded: true}
      break
    case OPEN_EDIT_PARTICIPANT_FORM:
      newState = {editParticipantFormVisible: true}
      break
    case OPEN_PARTICIPANT_FORM:
      newState = {participantFormVisible: true}
      break
    case OPEN_SLIDING_MODAL:
      newState = {
        slidingModalIsOpen: true,
        slidingModalContent: action.payload,
      }
      break
    case OPEN_USER_FORM:
      newState = {userFormVisible: true}
      break
    case SHOW_EVENT_DETAILS_LIST:
      newState = {eventDetailsListVisible: true}
      break
    case TOGGLE_EVENT_DETAILS:
      newState = {eventDetailsExpanded: !state.eventDetailsExpanded}
      break
    case SET_WEARER_TO_EDIT:
      newState = {wearerToEdit: action.userEventLookId}
      break
    case SET_SECTIONS_OPEN:
      newState = action.payload
      break
    case VALIDATE_DASHBOARD:
      newState = {shouldValidate: true}
      break
    default:
      break
  }

  return typeof newState === 'object' ? Object.assign({}, state, newState) : state
}
